import React, { Component } from 'react';

import './projects.css';

/*  
  */

let PROJECTS = require('./projects.json');

class Project extends Component {
  render() {
    var image_alt = this.props.title + " Image";
    var logo_alt = this.props.title + " Logo Image";
    var href = "/"; // + this.props.name;
    return (
      <div className="card">
        <div className="card-content">
          <div className="card-text">
              <img className="card-logo" src={this.props.logo} alt={logo_alt}/>
              <h6 className="card-title">{this.props.title}</h6>
              <p className="card-description">{this.props.description}</p>
              <div>
                  <a className="card-button" href={href}>View More {this.props.name}</a>
              </div>
          </div>
              <div className="card-img-big">
                  <a href={href}><img className="card-img-responsive" src={this.props.image_name} alt={image_alt}/></a>
              </div>
          </div>
      </div>
    );
  }
}

class Projects extends Component {
  render() {
    var projects = [];
    PROJECTS.forEach(function(project) {
      projects.push(
        <Project key={project.name} title={project.title} description={project.description} name={project.name}
        logo={project.logo} image_name={project.image_name} />
        );
    });
    return (
      <div className="projects">
        <div>
          <h2>What I've done so far</h2>
        </div>

        {projects}
      </div>
    );
  }
}

export default Projects;



/** WEBPACK FOOTER **
 ** ./src/projects/projects.js
 **/